// ./pages/About/index.jsx
import React from "react";

const Pagenotfound = () => {
  return (
    <>
      <div class="error_page position-relative">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="error_content position-relative text-center">
                <h1>404</h1>
                <p class="text">Sorry! The Page Not Found ;(</p>
                <p class="col-xl-8 col-lg-10 mx-auto text2">
                  Lorem ipsum dolor sit amet, consec tse tur adipiscing elit,
                  sed do eiusmod tempor incididunt ut labore
                </p>
                <a href="./index.html" class="back_home text-decoration-none">
                  <i class="fa-solid fa-arrow-left"></i>Back to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagenotfound;
